import { FC, ReactNode } from 'react';
import { PrimaryButtonStyled } from './styled';
import { ButtonProps } from 'utils/interfaces/button/button.interface';
import { themeColors } from 'assets/theme/style';

export interface PrimaryButtonProps extends ButtonProps {
  children?: ReactNode;
  testingTagLocation?: string;
}

const PrimaryButton: FC<PrimaryButtonProps> = ({
  text = '',
  clickHandler = (_e?: any) => {},
  textColor = themeColors.white,
  borderColor,
  backgroundColor,
  disabled = false,
  children,
  padding,
  gap,
  minWidth,
  height,
  type,
  width,
  borderRight
}) => (
  <PrimaryButtonStyled
    onClick={(e) => clickHandler(e)}
    textColor={textColor}
    backgroundColor={backgroundColor}
    borderColor={borderColor}
    disabled={disabled}
    padding={padding}
    gap={gap}
    minWidth={minWidth}
    height={height}
    type={type}
    width={width}
    borderRight={borderRight}
  >
    {children || text}
  </PrimaryButtonStyled>
);

export default PrimaryButton;
